import * as _ from 'lodash';
import { HLine } from "../area/HLine";
import { Point } from "../area/Point";
import { VLine } from "../area/VLine";
import { SC_Input } from "../input/SC_Input";
import * as konva from "../konva/getCanvas";
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import { RoofType } from "../roof/RoofType";
import { Global } from "../utilities/global";
import { ItemUtils } from "../utilities/ItemUtils";
import { MountingType } from "./MountingType";
import { Sol50OnRoof } from "./Sol50OnRoof";

import { RoofShape } from "../roof/RoofShape";
import { SC_Beam } from "../roof/SC_Beam";

import { SC_RoofHook } from "../stocklist/roofhook/SC_RoofHook";
import { RoofItemType } from './roofItemType';


//intersections joints hooks and
export class Intersections {

	public static RoofHook_draw(): void {
		var i: number;
		var dachhakTmp: Point;
		var aIntersections: any[];
		aIntersections = this.findIntersections();
		for (i = 0; i < aIntersections.length; i++) {
			dachhakTmp = aIntersections[i];
			const roofRook = konva.getCanvasRect({
				x: dachhakTmp.x - 7.5,
				y: dachhakTmp.y - 7.5,
				width: Sol50OnRoof.nRoofHookSize,
				height: Sol50OnRoof.nRoofHookSize,
				fill: Sol50OnRoof.uiRoofHookCol,
			});
			DrawRoofForPanel.subframeGroup.add(roofRook);
			roofRook.draw();
		}
	}

	//find intersections
	public static findIntersections(): any[] {
		var i: number;
		var j: number;
		var hprofilTmp: HLine;
		var vprofilTmp: VLine;
		var iResult: number = 0;
		var nDif: number;
		var nLeft: number;
		var nRight: number;
		var nY: number;
		var pTmp: Point;
		var aRet: any[] = new Array();
		Sol50OnRoof.aVProfile = _.sortBy(Sol50OnRoof.aVProfile, 'x');
		for (i = 0; i < Global.aHProfile.length; i++) {
			hprofilTmp = new HLine(Global.aHProfile[i]);
			nLeft = hprofilTmp.l;
			nRight = hprofilTmp.r;
			nY = hprofilTmp.y;
			for (j = 0; j < Sol50OnRoof.aVProfile.length; j++) {
				vprofilTmp = new VLine(Sol50OnRoof.aVProfile[j]);
				if (vprofilTmp.x < nRight) {
					if (vprofilTmp.x > nLeft) {
						if (vprofilTmp.t < nY && vprofilTmp.b > nY) {
							pTmp = new Point(vprofilTmp.x, nY);
							aRet.push(pTmp);
						}
					}
				} else {
					//no need to continue because the array was sorted by x
					break;
				}
			}
		}
		return [...aRet, ...Global.hookExtended];
	}

	public static getFastenComponents(): RoofItemType[] {
		var iTmp: number;
		var sRes: RoofItemType[] = [];
		if (SC_Input.iRoofType == RoofType.PANTILED) {
			sRes = sRes.concat(this.RoofHook_getString());
		} else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
			if (SC_Input.sStosch) {
				iTmp = this.getStoSch();
				sRes.push(new RoofItemType(NaN, Sol50OnRoof.sStoSchVeraufVar, ItemUtils.calculatePackingUnits(iTmp, Sol50OnRoof.nStoSchVeraufVPE)));
			}
		} else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
			if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
				if (SC_Input.sStosch) {
					iTmp = this.getStoSch();
					sRes.push(new RoofItemType(NaN, Sol50OnRoof.sStoSchVeraufVar, ItemUtils.calculatePackingUnits(iTmp, Sol50OnRoof.nStoSchVeraufVPE)));
				}
			}
		} else if (SC_Input.iRoofType == RoofType.SLATED) {
			iTmp = this.findIntersections().length;
			sRes.push(new RoofItemType(NaN, "SLATE_DUMMY", iTmp));
			sRes.push(new RoofItemType(NaN, "HNGR_BLT_WD_130", iTmp));
			sRes.push(new RoofItemType(NaN, Sol50OnRoof.sStoSchVeraufVar, ItemUtils.calculatePackingUnits(iTmp, Sol50OnRoof.nStoSchVeraufVPE)));
		} else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
			sRes = sRes.concat(this.RoofHook_getString());
			iTmp = this.findIntersections().length;
			sRes.push(new RoofItemType(NaN, "PLAIN_TILE_BRICK", iTmp));
		}
		return sRes;
	}

	public static getStoSch(): number {
		var iLen: number;
		this.StoSch_find();
		iLen = Sol50OnRoof.aStoSch.length;
		return iLen;
	}

	public static RoofHook_getString(): RoofItemType[] {
		this.RoofHook_getCnt();
		let sRet: RoofItemType[] = [];
		if (SC_Input.roofhookinputCurrent.iType == SC_RoofHook.TYPE_VARIO_DUO) {
			sRet.push(new RoofItemType(NaN, SC_Input.roofhookinputCurrent.sVarSuppShaftVarioDuo, (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount)));
		} else if (SC_Input.roofhookinputCurrent.iType == SC_RoofHook.TYPE_VARIO_SOLO) {
			sRet.push(new RoofItemType(NaN, SC_Input.roofhookinputCurrent.sVarSuppShaftVarioSolo, (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount)));
		}
		if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_BIG) {
			sRet.push(new RoofItemType(NaN, SC_Input.roofhookinputCurrent.sVarBasePlateBig, Sol50OnRoof.iRoofHookBigCount));
		} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_SMALL) {
			sRet.push(new RoofItemType(NaN, SC_Input.roofhookinputCurrent.sVarBasePlateSmall, Sol50OnRoof.iRoofHookSmallCount));
		} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_MIXED) {
			sRet.push(new RoofItemType(NaN, SC_Input.roofhookinputCurrent.sVarBasePlateBig, Sol50OnRoof.iRoofHookBigCount));
			sRet.push(new RoofItemType(NaN, SC_Input.roofhookinputCurrent.sVarBasePlateSmall, Sol50OnRoof.iRoofHookSmallCount));
		}
		return sRet;
	}
	//get amount
	public static RoofHook_getCnt(): void {
		var iLen: number;
		var aIntersections: any[];
		aIntersections = this.findIntersections();
		iLen = aIntersections.length;
		if (iLen % 2 == 0) {
			Sol50OnRoof.iRoofHookBigCount = iLen / 2;
			Sol50OnRoof.iRoofHookSmallCount = iLen / 2;
		} else {
			Sol50OnRoof.iRoofHookBigCount = parseInt("" + Math.ceil(iLen / 2));
			Sol50OnRoof.iRoofHookSmallCount = parseInt("" + iLen / 2);
		}
		if (SC_Input.iBeamType == SC_Beam.RAFTER) {
			if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_BIG) {
				Sol50OnRoof.iRoofHookBigCount = iLen;
				Sol50OnRoof.iRoofHookSmallCount = 0;
			} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_SMALL) {
				Sol50OnRoof.iRoofHookBigCount = 0;
				Sol50OnRoof.iRoofHookSmallCount = iLen;
			} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_MIXED) {
				//fit already
			}
		}
	}

	//zeichnen
	public static drawStoSch(): void {
		var i: number, j: number;
		var StoSchTmp: Point;
		this.StoSch_find();
		setTimeout(() => {
			for (i = 0; i < Sol50OnRoof.aStoSch.length; i++) {
				// StoSchTmp = new Point(Sol50OnRoof.aStoSch[i], null);
				// Global.pageDesign.canFramework.graphics.beginFill(Sol50OnRoof.uiStoSchCol);
				// Global.pageDesign.canFramework.graphics.drawRect(StoSchTmp.x - 7.5, StoSchTmp.y - 7.5, Sol50OnRoof.nStoSchHeight, Sol50OnRoof.nStoSchHeight);
				// Global.pageDesign.canFramework.graphics.endFill();
				const StoSch = konva.getCanvasRect({
					x: Sol50OnRoof.aStoSch[i].x - 7.5,
					y: Sol50OnRoof.aStoSch[i].y - 7.5,
					width: Sol50OnRoof.nStoSchHeight,
					height: Sol50OnRoof.nStoSchHeight,
					fill: Sol50OnRoof.uiStoSchCol,
				});
				DrawRoofForPanel.subframeGroup.add(StoSch);
				StoSch.draw();
			}
		}, 200);

	}

	//StoSch find
	public static StoSch_find(): void {
		var i: number;
		var j: number;
		var hprofilTmp: HLine;
		var vprofilTmp: VLine;
		var iResult: number = 0;
		var nDif: number;
		var nLeft: number;
		var nRight: number;
		var nY: number;
		var pTmp: Point;
		var aPurlin: any[];
		var nRoofHeight: number;
		var nRoofWidth: number;
		//Pfetten
		aPurlin = new Array();
		nY = SC_Input.nBeamDist2 + 100;
		nRoofHeight = RoofShape.getCurrentRoofHeight() + 100;
		nRoofWidth = RoofShape.getCurrentRoofWidth() + 100;
		while (nY <= nRoofHeight) {
			hprofilTmp = new HLine(null);
			hprofilTmp.l = 100;
			hprofilTmp.r = nRoofWidth + 100;
			hprofilTmp.y = nY;
			aPurlin.push(hprofilTmp);
			nY += SC_Input.nBeamDist;
		}
		// console.log("202");
		Sol50OnRoof.aStoSch = new Array();
		// Sol50OnRoof.aVProfile.sortOn("x", Array.NUMERIC);
		Sol50OnRoof.aVProfile = _.sortBy(Sol50OnRoof.aVProfile, 'x');
		for (i = 0; i < aPurlin.length; i++) {
			hprofilTmp = new HLine(aPurlin[i]);
			nLeft = hprofilTmp.l;
			nRight = hprofilTmp.r;
			nY = hprofilTmp.y;
			for (j = 0; j < Sol50OnRoof.aVProfile.length; j++) {
				vprofilTmp = new VLine(Sol50OnRoof.aVProfile[j]);
				if (vprofilTmp.x < nRight) {
					if (vprofilTmp.x > nLeft) {
						if (vprofilTmp.t < nY && vprofilTmp.b > nY) {
							pTmp = new Point(vprofilTmp.x, nY);
							Sol50OnRoof.aStoSch.push(pTmp);
						}
					}
				} else {
					//no need to continue because the array was sorted by x
					break;
				}
			}
		}
	}
}
